// Contact.jsx
import phone from '../images/contact/phone-solid.svg';
import email from '../images/contact/envelope-solid.svg';
import loc from '../images/contact/location-dot-solid.svg';
import qr from '../images/bank_qr.jpg';
import '../scss/Contact.scss';

const Contact = () => {
    return (
        <div className="contact-page">
            <div className="contact-container">
                {/* Header */}
                <div className="contact-header">
                    <h1 className="page-title">Contact & Support</h1>
                    <p className="page-subtitle">
                        Get in touch with us or make a donation to support our cause
                    </p>
                </div>

                {/* Main Grid */}
                <div className="contact-grid">
                    
                    {/* Donation & Tax Info - Featured Card */}
                    <div className="contact-card featured-card">
                        <div className="card-header">
                            <div className="icon-wrapper">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                    <polyline points="14 2 14 8 20 8"/>
                                    <line x1="16" y1="13" x2="8" y2="13"/>
                                    <line x1="16" y1="17" x2="8" y2="17"/>
                                    <polyline points="10 9 9 9 8 9"/>
                                </svg>
                            </div>
                            <div>
                                <h2>Donation & Tax Benefits</h2>
                                <p className="highlight-text">
                                    Your donation is eligible for tax exemption under Section 80G
                                </p>
                            </div>
                        </div>
                        
                        <div className="tax-info-grid">
                            <div className="tax-info-item">
                                <p className="label">PAN Number</p>
                                <p className="value">AABTC4114G</p>
                            </div>
                            <div className="tax-info-item">
                                <p className="label">80G Registration</p>
                                <p className="value">AABTC4114GF20212</p>
                            </div>
                            <div className="tax-info-item">
                                <p className="label">Registration Date</p>
                                <p className="value">19-11-2021</p>
                            </div>
                        </div>
                    </div>

                    {/* Bank Details Card */}
                    <div className="contact-card bank-card">
                        <div className="card-title">
                            <div className="icon-badge bank">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <line x1="3" y1="22" x2="21" y2="22"/>
                                    <line x1="6" y1="18" x2="6" y2="11"/>
                                    <line x1="10" y1="18" x2="10" y2="11"/>
                                    <line x1="14" y1="18" x2="14" y2="11"/>
                                    <line x1="18" y1="18" x2="18" y2="11"/>
                                    <polygon points="12 2 20 7 4 7"/>
                                </svg>
                            </div>
                            <h2>Bank Details</h2>
                        </div>

                        <div className="info-rows">
                            <div className="info-row">
                                <span className="info-label">Account Name</span>
                                <span className="info-value">CURE</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Account Number</span>
                                <span className="info-value">17162010012241</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Account Type</span>
                                <span className="info-value">Savings Bank</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">IFSC Code</span>
                                <span className="info-value">CNRB0000875</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Bank</span>
                                <span className="info-value">Canara Bank</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Branch</span>
                                <span className="info-value">Tilaknagar, Mysore</span>
                            </div>
                        </div>

                        <div className="qr-section">
                            <p className="qr-title">Scan to Donate</p>
                            <div className="qr-wrapper">
                                <img src={qr} alt="Donation QR Code" className="qr-image" />
                            </div>
                        </div>
                    </div>

                    {/* Registered Office Card */}
                    <div className="contact-card office-card registered">
                        <div className="card-title">
                            <div className="icon-badge registered">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <rect x="3" y="3" width="7" height="7"/>
                                    <rect x="14" y="3" width="7" height="7"/>
                                    <rect x="14" y="14" width="7" height="7"/>
                                    <rect x="3" y="14" width="7" height="7"/>
                                </svg>
                            </div>
                            <h2>Registered Office</h2>
                        </div>

                        <div className="office-content">
                            <div className="address-section">
                                <img src={loc} className="address-icon" alt="Location" />
                                <div className="address-text">
                                    <p className="org-name">
                                        Charity for Urban and Rural Enhancement (CURE)
                                    </p>
                                    <p>ICRM Campus, Mahadevapura,</p>
                                    <p>Mysore – 570008</p>
                                </div>
                            </div>

                            <div className="contact-links">
                                <a href="tel:+919845559119" className="contact-link">
                                    <img src={phone} className="link-icon" alt="Phone" />
                                    <span>+91 98455 59119</span>
                                </a>
                                <a href="mailto:headoffice@cure-india.org" className="contact-link">
                                    <img src={email} className="link-icon" alt="Email" />
                                    <span>headoffice@cure-india.org</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Admin Office Card */}
                    <div className="contact-card office-card admin full-width">
                        <div className="card-title">
                            <div className="icon-badge admin">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <rect x="3" y="3" width="7" height="7"/>
                                    <rect x="14" y="3" width="7" height="7"/>
                                    <rect x="14" y="14" width="7" height="7"/>
                                    <rect x="3" y="14" width="7" height="7"/>
                                </svg>
                            </div>
                            <h2>Administrative Office</h2>
                        </div>

                        <div className="admin-content">
                            <div className="address-section">
                                <img src={loc} className="address-icon" alt="Location" />
                                <div className="address-text">
                                    <p className="org-name">
                                        Charity for Urban and Rural Enhancement (CURE)
                                    </p>
                                    <p>#1/2, "C" Block, Janatha Colony,</p>
                                    <p>2nd Cross, Halleguddadaha Halli,</p>
                                    <p>Mysore Road, Bangalore – 560026</p>
                                    <p>Karnataka, India</p>
                                </div>
                            </div>

                            <div className="contact-links">
                                <a href="tel:+918553355463" className="contact-link">
                                    <img src={phone} className="link-icon" alt="Phone" />
                                    <span>+91 85533 55463</span>
                                </a>
                                <a href="mailto:headoffice@cure-india.org" className="contact-link">
                                    <img src={email} className="link-icon" alt="Email" />
                                    <span>headoffice@cure-india.org</span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Contact;